
import { defineComponent } from "vue";
import { RouterLink, useRoute } from "vue-router";

import EmptyState from "../components/empty-state.vue";
import common from "../styles/common.module.less";

// /xiyou/* 未匹配路径的兜底页（不白屏）
export default defineComponent({
  name: "XiyouNotFound",
  setup() {
    const route = useRoute();
    return () => (
      <div class={common.shell}>
        <EmptyState
          title="页面不存在"
          desc={`未找到路径 ${route.fullPath}，请通过上方菜单继续浏览。`}
          icon="alert"
        >
          <RouterLink
            class={[common.btn, common.btnPrimary]}
            to={{ name: "XiyouHome" }}
          >
            返回首页
          </RouterLink>
        </EmptyState>
      </div>
    );
  },
});
